import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cancel-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './cancel-button.component.html',
  styleUrl: './cancel-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancelButtonComponent {
  @Output() readonly onCancelClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.onCancelClicked.emit();
  }
}
